export default function() {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  
  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
      , detectIpad: IPADDETECTED
      // options
      , allEventsLink: false
      , allEventsLinkText: ''
      , hasImages: false
      , imageBackground: false
      , lazyLoadImages: false
      , buyNowButton: {visible: false, text: ''}
      , moreButton: {visible: false, text: ''}
      , maxItemsVisible: 5
      , isResponsive: false
      , hasDescription: false
      , textContainer: false
      , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
      , attributeOrder: {
        1: 'date',
        2: 'title',
        3: 'image',
        4: 'description',
        5: 'buttons'
      }
      , multiFeatureLoaded: function(data){
        $('<span class="widget-title">Coming Up</span>').prependTo('.multiFeatureContent');

        $('#multiScheduleFeature .featureItem').each(function() {
          const eventDate = $(this).find($('span.featureItemDate'));
          const dateYear = eventDate.text().slice(-4);
          const dateMonth = eventDate.text().slice(0, 3);
          const dateDay = eventDate.text().slice(4, 7).replace(',', '');

          eventDate.text(dateMonth);
          eventDate.append(`<span class='day'>${dateDay}</span>`);
          eventDate.append(`<span class='year'>${dateYear}</span>`);

          const itemTitle = $(this).find('.featureItemTitle');
          const characterLimit = 50;
          const itemTitleText = itemTitle.text();

          if ( itemTitleText.length > characterLimit ) {
            const trimmedText = itemTitleText.substring(0,characterLimit) + '...';
            itemTitle.text(trimmedText);
          }
        });
      }
  });

};

